import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import useInfoNavigation from '../../../hooks/useInfoNavigation';
import { FE_PIGGY_BANK } from '../../../utils/featureFlags/constants';
import QueryParamProxy from '../../../utils/queryParamProxy';
import routeParamConstants from '../../../utils/routeParamConstants';
import { generatePiggyBankInfoRendering, generatePiggyBankRendering } from '../utils/generatePiggyBankRendering';
import { sendPiggyBankEvent } from '../analytics/piggyBankLogger';
import { PIGGY_BANK_EVENT_TYPES, PIGGY_BANK_PROGRESS, PIGGY_BANK_RUNNING_STATUS } from '../constants';
import { useGetPiggyBankQuery, invalidatePiggy } from '../../../state/query/piggyBank';
import { useGetBillingProfilesQuery } from '../../../state/query/purchase';
import Utils from '../../../utils/platform';
import { getText, TEXT_KEY } from '../../../utils/localization';
import useNotification from '../../../hooks/useNotification';
import { HTTP_STATUS } from '../../../state/api/services/utils/constants';

/** @typedef {import('../../../state/query/piggyBank/queries').PiggyBankFeatureState} PiggyBankFeatureState */
var isWeb = Utils.isWebOrMobileWeb();
var usePiggyBank = function usePiggyBank(_ref) {
  var _data$piggyBankFeatur, _piggyBankFeatureStat3, _piggyBankFeatureStat5, _piggyBankFeatureStat6;
  var dismissModal = _ref.dismissModal;
  var dispatch = useDispatch();
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  var _useGetBillingProfile = useGetBillingProfilesQuery(),
    isFetching = _useGetBillingProfile.isFetching;
  var _useNotification = useNotification(),
    addNotification = _useNotification.addNotification;
  useEffect(function () {
    if (!hasFeature(FE_PIGGY_BANK)) dismissModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useGetPiggyBankQuery = useGetPiggyBankQuery({}, {
      forceRefetch: true,
      refetchOnMountOrArgChange: true
    }),
    data = _useGetPiggyBankQuery.data,
    error = _useGetPiggyBankQuery.error,
    isError = _useGetPiggyBankQuery.isError,
    isSuccess = _useGetPiggyBankQuery.isSuccess;
  var piggyBankFeatureState = data === null || data === void 0 ? void 0 : data.piggyBankFeatureState;
  var hasTutorial = QueryParamProxy.findParam(routeParamConstants.PARAM_PIGGY_BANK_TUTORIAL, false);
  var piggyBankBrokenParam = QueryParamProxy.findParam(routeParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, false);
  var is404Error = (error === null || error === void 0 ? void 0 : error.status) === HTTP_STATUS.NOT_FOUND;
  var shouldShowError = isError && !is404Error || isSuccess && piggyBankFeatureState.piggyBankSetup === null && piggyBankBrokenParam !== 'true';
  var piggyBankRunningStatus = data === null || data === void 0 || (_data$piggyBankFeatur = data.piggyBankFeatureState) === null || _data$piggyBankFeatur === void 0 || (_data$piggyBankFeatur = _data$piggyBankFeatur.piggyBankSetup) === null || _data$piggyBankFeatur === void 0 ? void 0 : _data$piggyBankFeatur.piggyBankRunningStatus;
  var _useSelector = useSelector(function (state) {
      return {
        rawAssets: state.assetsPackage.assets,
        purchaseProfile: state.prePurchase.purchaseProfile
      };
    }, shallowEqual),
    rawAssets = _useSelector.rawAssets,
    purchaseProfile = _useSelector.purchaseProfile;
  var piggyBankAssets = useMemo(function () {
    return (rawAssets === null || rawAssets === void 0 ? void 0 : rawAssets.PIGGY_BANK_FEATURE) || {};
  }, [rawAssets === null || rawAssets === void 0 ? void 0 : rawAssets.PIGGY_BANK_FEATURE]);
  var coinsAnimationRef = useRef(null);
  var uuidRef = useRef(null);
  var navigationData = useInfoNavigation({
    tutorialScreens: generatePiggyBankInfoRendering(piggyBankAssets, piggyBankFeatureState === null || piggyBankFeatureState === void 0 ? void 0 : piggyBankFeatureState.piggyBankInfoScreenType)
  });
  useEffect(function () {
    if (piggyBankBrokenParam === 'true') {
      coinsAnimationRef.current.triggerAnimation();
      if (!isWeb) dispatch(invalidatePiggy());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [piggyBankBrokenParam]);
  var piggyBankRendering = useMemo(function () {
    var _piggyBankFeatureStat, _piggyBankFeatureStat2;
    return generatePiggyBankRendering(piggyBankAssets, {
      progress: (_piggyBankFeatureStat = piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat2 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat2 === void 0 ? void 0 : _piggyBankFeatureStat2.progress) !== null && _piggyBankFeatureStat !== void 0 ? _piggyBankFeatureStat : 0,
      piggyBankBrokenParam: piggyBankBrokenParam
    });
  }, [piggyBankAssets, piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat3 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat3 === void 0 ? void 0 : _piggyBankFeatureStat3.progress, piggyBankBrokenParam]);
  useEffect(function () {
    if (hasTutorial && piggyBankRunningStatus === PIGGY_BANK_RUNNING_STATUS.RUNNING) {
      navigationData.handleOpenModal();
      QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_PIGGY_BANK_TUTORIAL, undefined), routeParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, undefined));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTutorial, piggyBankRunningStatus]);
  useEffect(function () {
    return function () {
      QueryParamProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, undefined));
    };
  }, []);
  var showErrorNotification = function showErrorNotification() {
    addNotification({
      title: getText(TEXT_KEY.OOPS),
      message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
      button: getText(TEXT_KEY.OK),
      hideCloseButton: true,
      hideHelpButton: true,
      buttonAction: function buttonAction() {
        dismissModal();
        QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_PIGGY_BANK_TUTORIAL, undefined), routeParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, undefined));
      }
    });
  };
  useEffect(function () {
    if (shouldShowError) showErrorNotification();
  }, [shouldShowError]);
  useEffect(function () {
    var _piggyBankFeatureStat4;
    var uuid = piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat4 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat4 === void 0 ? void 0 : _piggyBankFeatureStat4.uuid;
    if (isSuccess && uuid && uuid !== uuidRef.current) {
      sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.ENTER_PIGGY_BANK_SCREEN, {
        uuid: uuid
      });
      uuidRef.current = uuid;
    }
  }, [isSuccess, piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat5 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat5 === void 0 ? void 0 : _piggyBankFeatureStat5.uuid]);
  useEffect(function () {
    return function () {
      if (uuidRef.current) {
        sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.EXIT_PIGGY_BANK_SCREEN, {
          uuid: uuidRef.current
        });
      }
    };
  }, []);
  return _objectSpread(_objectSpread(_objectSpread({}, navigationData), piggyBankRendering), {}, {
    piggyBankFeatureState: piggyBankFeatureState,
    piggyBankAssets: piggyBankAssets,
    isBroken: piggyBankBrokenParam === 'true',
    coinsAnimationRef: coinsAnimationRef,
    availableToBreak: !(isWeb && isFetching && (purchaseProfile === null || purchaseProfile === void 0 ? void 0 : purchaseProfile.length) === 0) && (piggyBankFeatureState === null || piggyBankFeatureState === void 0 || (_piggyBankFeatureStat6 = piggyBankFeatureState.breakPackage) === null || _piggyBankFeatureStat6 === void 0 ? void 0 : _piggyBankFeatureStat6.progress) === PIGGY_BANK_PROGRESS.FULL
  });
};
export default usePiggyBank;